(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.onload = () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-women-exercises"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gtp-exercises')) {
 customElements.define('gtp-exercises', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.tabs = [...this.querySelectorAll('[role="tab"]')];
   this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
   this.tabs.forEach((tab,index) => {
    tab.addEventListener('click',()=>this.select(index));
    tab.addEventListener('keydown',event=>{
     const next = {ArrowRight:(index+1)%this.tabs.length,ArrowLeft:(index-1+this.tabs.length)%this.tabs.length,Home:0,End:this.tabs.length-1}[event.key];
     if(next===undefined) return;
     event.preventDefault(); this.select(next); this.tabs[next].focus();
    });
   });
   this.querySelectorAll('[data-exercise]').forEach(button=>button.addEventListener('click',()=>this.exercise(button.closest('[role="tabpanel"]'),button.dataset.exercise)));
   this.observer = new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting) {
     this.playCurrent(!matchMedia('(prefers-reduced-motion: reduce)').matches);
    } else this.pauseAll();
   },{threshold:0.2});
   this.observer.observe(this);
   this.warmer = new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting && !navigator.connection?.saveData) {
     const video=this.querySelector('[role="tabpanel"]:not([hidden]) [data-exercise-player]:not([hidden]) video');
     this.prepare(video,'auto');this.warmer.disconnect();
    }
   },{rootMargin:'500px 0px'});
   this.warmer.observe(this);
   this.querySelectorAll('[data-exercise], [role="tab"]').forEach(button=>{
    const warm=()=>{
     if(navigator.connection?.saveData)return;
     const panel=button.closest('[role="tabpanel"]') || this.panels[this.tabs.indexOf(button)];
     const player=button.dataset.exercise ? [...panel.querySelectorAll('[data-exercise-player]')].find(p=>p.dataset.exercisePlayer===button.dataset.exercise) : panel.querySelector('[data-exercise-player]:not([hidden])');
     this.prepare(player?.querySelector('video'),'metadata');
    };
    button.addEventListener('pointerenter',warm);button.addEventListener('focus',warm);button.addEventListener('touchstart',warm,{passive:true});
   });
   this.visibility = ()=>{if(document.hidden)this.pauseAll();};
   document.addEventListener('visibilitychange',this.visibility);
   this.addEventListener('shopify:block:select',event=>{
    const copy=event.target.closest('[data-exercise-copy]');
    if(!copy)return;
    const panel=copy.closest('[role="tabpanel"]');this.select(this.panels.indexOf(panel));this.exercise(panel,copy.dataset.exerciseCopy);
   });
  }
  disconnectedCallback(){this.observer?.disconnect();this.warmer?.disconnect();document.removeEventListener('visibilitychange',this.visibility);this.pauseAll();this.initialized=false;}
  pauseAll(){this.querySelectorAll('video').forEach(video=>video.pause());}
  prepare(video,preload='metadata'){
   if(!video?.dataset.src)return;
   video.preload=preload;
   if(!video.getAttribute('src')) {video.src=video.dataset.src;video.load();}
  }
  playCurrent(autoplay=true){
   const video=this.querySelector('[role="tabpanel"]:not([hidden]) [data-exercise-player]:not([hidden]) video');
   if(!video || !video.dataset.src)return;
   this.querySelectorAll('video').forEach(other=>{if(other!==video && other.getAttribute('src')){other.pause();other.removeAttribute('src');other.preload='none';other.load();}});
   this.prepare(video,'auto');
   video.muted=true;if(autoplay)video.play().catch(()=>{});
  }
  select(index){
   this.pauseAll();
   this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});
   this.playCurrent();
   this.tabs[index].scrollIntoView({block:'nearest',inline:'nearest'});
  }
  exercise(panel,id){
   this.pauseAll();
   panel.querySelectorAll('[data-exercise]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.exercise===id)));
   panel.querySelectorAll('[data-exercise-copy]').forEach(copy=>copy.hidden=copy.dataset.exerciseCopy!==id);
   panel.querySelectorAll('[data-exercise-player]').forEach(player=>player.hidden=player.dataset.exercisePlayer!==id);
   this.playCurrent();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-women-ugc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setup(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const viewport = root.querySelector('.gtp-ugc__window');
      const track = root.querySelector('.gtp-ugc__track');
      const originals = [...track.children];
      if (!originals.length) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, warm = false, stopped = false, offset = 0, last = 0, frame = 0, step = 0;
      const near = new Set();
      const playing = new Set();
      const canMove = () => visible && !document.hidden && !reduced.matches && !stopped;
      const sync = video => {
        const nearby = warm && near.has(video);
        if (nearby && video.dataset.poster && !video.getAttribute('poster')) {
          video.poster = video.dataset.poster;
        }
        // A poster is sufficient off screen or when the visitor requests less data/motion.
        const loadClip = nearby && !reduced.matches && !navigator.connection?.saveData;
        if (loadClip && !video.getAttribute('src')) {
          video.preload = 'metadata';
          video.src = video.dataset.src;
        } else if (!nearby && video.getAttribute('src')) {
          video.pause();
          video.removeAttribute('src');
          video.preload = 'none';
          video.load();
        }
        video.muted = true;
        if (loadClip && playing.has(video) && canMove()) {
          if (video.paused) video.play().catch(() => {});
        } else if (!video.paused) video.pause();
      };
      const loadObserver = new IntersectionObserver(entries => {
        entries.forEach(({target, isIntersecting}) => {
          if (isIntersecting) near.add(target); else near.delete(target);
          sync(target);
        });
      }, { root: viewport, rootMargin: '0px 120px', threshold: 0 });
      const playObserver = new IntersectionObserver(entries => {
        entries.forEach(({target, isIntersecting}) => {
          if (isIntersecting) playing.add(target); else playing.delete(target);
          sync(target);
        });
      }, { root: viewport, threshold: .05 });
      const observe = card => {
        const video = card.querySelector('video');
        video.muted = true;
        video.addEventListener('loadeddata', () => { if (reduced.matches && video.currentTime === 0) video.currentTime = .1; });
        loadObserver.observe(video);
        playObserver.observe(video);
      };
      originals.forEach(observe);
      const resize = new ResizeObserver(() => {
        step = originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        while (track.children.length * step < viewport.clientWidth + step * 2) {
          const copy = originals[track.children.length % originals.length].cloneNode(true);
          copy.removeAttribute('data-shopify-editor-block');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelector('video').removeAttribute('src');
          track.append(copy);
          observe(copy);
        }
      });
      resize.observe(viewport);
      const tick = time => {
        frame = 0;
        if (!root.isConnected || !canMove()) { last = 0; return; }
        if (last) offset += Math.min(time - last, 50) * .022;
        last = time;
        const first = track.firstElementChild;
        if (step && offset >= step) { offset -= step; track.append(first); }
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        frame = requestAnimationFrame(tick);
      };
      const refresh = () => {
        track.querySelectorAll('video').forEach(sync);
        if (canMove() && !frame) frame = requestAnimationFrame(tick);
        if (!canMove()) { cancelAnimationFrame(frame); frame = 0; last = 0; }
        if (reduced.matches) { offset = 0; track.style.transform = ''; }
      };
      const sectionObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        refresh();
      });
      sectionObserver.observe(root);
      // Fetch nearby clips before vertical scrolling reaches the strip. Posters
      // remain visible while buffering or when mobile Safari blocks autoplay.
      const warmObserver = new IntersectionObserver(entries => {
        warm = entries[0].isIntersecting;
        refresh();
      }, { rootMargin: '350px 0px' });
      warmObserver.observe(root);
      viewport.addEventListener('click', () => { stopped = !stopped; refresh(); });
      viewport.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); stopped = !stopped; refresh(); } });
      document.addEventListener('visibilitychange', refresh);
      reduced.addEventListener('change', refresh);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        cancelAnimationFrame(frame); loadObserver.disconnect(); playObserver.disconnect(); sectionObserver.disconnect(); warmObserver.disconnect(); resize.disconnect();
        document.removeEventListener('visibilitychange', refresh); reduced.removeEventListener('change', refresh);
      });
    }
    document.querySelectorAll('[data-gtp-ugc]').forEach(setup);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gtp-ugc]').forEach(setup));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-attachments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gtp-attachments'))customElements.define('gtp-attachments',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];this.images=[...this.querySelectorAll('[data-mount-image]')];this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index));tab.addEventListener('keydown',event=>{const next={ArrowRight:(index+1)%this.tabs.length,ArrowDown:(index+1)%this.tabs.length,ArrowLeft:(index-1+this.tabs.length)%this.tabs.length,ArrowUp:(index-1+this.tabs.length)%this.tabs.length,Home:0,End:this.tabs.length-1}[event.key];if(next===undefined)return;event.preventDefault();this.select(next);this.tabs[next].focus()})});this.addEventListener('shopify:block:select',event=>{const n=this.panels.findIndex(p=>p.contains(event.target));if(n>=0)this.select(n)})}
 select(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;this.images[i].hidden=i!==index})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-compare-choice]');
  if (!button) return;
  const section = button.closest('[data-gtp-comparison]');
  section.dataset.selected = button.dataset.compareChoice;
  section.querySelectorAll('[data-compare-choice]').forEach(function(choice) {
    choice.setAttribute('aria-pressed', String(choice === button));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-exercises"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gtp-exercises')) {
 customElements.define('gtp-exercises', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.tabs = [...this.querySelectorAll('[role="tab"]')];
   this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
   this.tabs.forEach((tab,index) => {
    tab.addEventListener('click',()=>this.select(index));
    tab.addEventListener('keydown',event=>{
     const next = {ArrowRight:(index+1)%this.tabs.length,ArrowLeft:(index-1+this.tabs.length)%this.tabs.length,Home:0,End:this.tabs.length-1}[event.key];
     if(next===undefined) return;
     event.preventDefault(); this.select(next); this.tabs[next].focus();
    });
   });
   this.querySelectorAll('[data-exercise]').forEach(button=>button.addEventListener('click',()=>this.exercise(button.closest('[role="tabpanel"]'),button.dataset.exercise)));
   this.observer = new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting) {
     this.playCurrent(!matchMedia('(prefers-reduced-motion: reduce)').matches);
    } else this.pauseAll();
   },{threshold:0.2});
   this.observer.observe(this);
   this.warmer = new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting && !navigator.connection?.saveData) {
     const video=this.querySelector('[role="tabpanel"]:not([hidden]) [data-exercise-player]:not([hidden]) video');
     this.prepare(video,'auto');this.warmer.disconnect();
    }
   },{rootMargin:'500px 0px'});
   this.warmer.observe(this);
   this.querySelectorAll('[data-exercise], [role="tab"]').forEach(button=>{
    const warm=()=>{
     if(navigator.connection?.saveData)return;
     const panel=button.closest('[role="tabpanel"]') || this.panels[this.tabs.indexOf(button)];
     const player=button.dataset.exercise ? [...panel.querySelectorAll('[data-exercise-player]')].find(p=>p.dataset.exercisePlayer===button.dataset.exercise) : panel.querySelector('[data-exercise-player]:not([hidden])');
     this.prepare(player?.querySelector('video'),'metadata');
    };
    button.addEventListener('pointerenter',warm);button.addEventListener('focus',warm);button.addEventListener('touchstart',warm,{passive:true});
   });
   this.visibility = ()=>{if(document.hidden)this.pauseAll();};
   document.addEventListener('visibilitychange',this.visibility);
   this.addEventListener('shopify:block:select',event=>{
    const copy=event.target.closest('[data-exercise-copy]');
    if(!copy)return;
    const panel=copy.closest('[role="tabpanel"]');this.select(this.panels.indexOf(panel));this.exercise(panel,copy.dataset.exerciseCopy);
   });
  }
  disconnectedCallback(){this.observer?.disconnect();this.warmer?.disconnect();document.removeEventListener('visibilitychange',this.visibility);this.pauseAll();this.initialized=false;}
  pauseAll(){this.querySelectorAll('video').forEach(video=>video.pause());}
  prepare(video,preload='metadata'){
   if(!video?.dataset.src)return;
   video.preload=preload;
   if(!video.getAttribute('src')) {video.src=video.dataset.src;video.load();}
  }
  playCurrent(autoplay=true){
   const video=this.querySelector('[role="tabpanel"]:not([hidden]) [data-exercise-player]:not([hidden]) video');
   if(!video || !video.dataset.src)return;
   this.querySelectorAll('video').forEach(other=>{if(other!==video && other.getAttribute('src')){other.pause();other.removeAttribute('src');other.preload='none';other.load();}});
   this.prepare(video,'auto');
   video.muted=true;if(autoplay)video.play().catch(()=>{});
  }
  select(index){
   this.pauseAll();
   this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index;});
   this.playCurrent();
   this.tabs[index].scrollIntoView({block:'nearest',inline:'nearest'});
  }
  exercise(panel,id){
   this.pauseAll();
   panel.querySelectorAll('[data-exercise]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.exercise===id)));
   panel.querySelectorAll('[data-exercise-copy]').forEach(copy=>copy.hidden=copy.dataset.exerciseCopy!==id);
   panel.querySelectorAll('[data-exercise-player]').forEach(player=>player.hidden=player.dataset.exercisePlayer!==id);
   this.playCurrent();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-homegym-listicle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateDispatchCountdown = () => {
      const countdowns = document.querySelectorAll('[data-gtp-dispatch-countdown]');
      if (!countdowns.length) return;

      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const remaining = Math.max(0, Math.ceil((midnight - now) / 1000));
      const value = [
        Math.floor(remaining / 3600),
        Math.floor((remaining % 3600) / 60),
        remaining % 60
      ].map((unit) => String(unit).padStart(2, '0')).join(':');

      countdowns.forEach((countdown) => {
        countdown.textContent = value;
      });
    };

    updateDispatchCountdown();
    if (!window.__gtpDispatchCountdownTimer) {
      window.__gtpDispatchCountdownTimer = window.setInterval(updateDispatchCountdown, 1000);
    }

    const initializeProgress = (section) => {
      if (!section || section.dataset.progressInitialized === 'true') return;

      const track = section.querySelector('[data-hg-progress]');
      if (!track) return;

      section.dataset.progressInitialized = 'true';
      let ticking = false;

      const updateProgress = () => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const offer = document.getElementById('gtp-offer');
        const sectionEnd = offer
          ? offer.getBoundingClientRect().top + window.scrollY
          : section.getBoundingClientRect().bottom + window.scrollY;
        const readingDistance = Math.max(1, sectionEnd - sectionTop - window.innerHeight);
        const progress = Math.min(1, Math.max(0, (window.scrollY - sectionTop) / readingDistance));

        track.style.setProperty('--hg-progress', progress.toFixed(4));
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateProgress();
    };

    document.querySelectorAll('.gtp-hg').forEach(initializeProgress);
    document.addEventListener('shopify:section:load', (event) => {
      initializeProgress(event.target.querySelector('.gtp-hg'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-top-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gtp-top-section')) {
    customElements.define('gtp-top-section', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('[data-top-track]');
        this.slides = [...this.querySelectorAll('[data-top-slide]')];
        this.thumbs = this.querySelector('[data-top-thumbs]');
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', (event) => {
          const go = event.target.closest('[data-top-go]');
          const direction = event.target.closest('[data-top-direction]');
          if (go) {
            const targetIndex = Number(go.dataset.topGo);
            this.go(targetIndex);
            if (go.classList.contains('gtp-top__watch')) {
              this.slides[targetIndex]?.querySelector('video')?.play().catch(() => {});
            }
          }
          if (direction) this.go((this.index + Number(direction.dataset.topDirection) + this.slides.length) % this.slides.length);
          const guarantee = event.target.closest('a[href^="#gtp-top-guarantee-"]');
          if (guarantee) {
            const details = this.querySelector(guarantee.getAttribute('href'));
            if (details) details.open = true;
          }
        }, {signal});
        let frame;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.syncGallery());
        }, {passive:true,signal});
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.go(Math.max(0,Math.min(this.slides.length-1,this.index+(event.key === 'ArrowRight' ? 1 : -1))));
        }, {signal});
        this.form = this.querySelector('.gtp-top__form');
        this.atc = this.querySelector('[data-top-atc]');
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-top-tier]')) this.syncTier();
        }, {signal});
        this.syncTier();
        this.form.addEventListener('submit', (event) => this.addToCart(event), {capture:true,signal});
        const sticky = this.querySelector('[data-top-sticky]');
        this.stickyObserver = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        }, {threshold:0});
        this.stickyObserver.observe(this.querySelector('.gtp-top__offer'));
        this.querySelector('[data-top-sticky-link]').addEventListener('click', (event) => {
          event.preventDefault();
          const offer = this.querySelector('.gtp-top__offer');
          offer.scrollIntoView({behavior:this.reduced.matches?'instant':'smooth',block:'start'});
          offer.focus({preventScroll:true});
        }, {signal});
      }
      disconnectedCallback() { this.abort?.abort(); this.stickyObserver?.disconnect(); }
      go(index) {
        const slide = this.slides[index];
        if (!slide) return;
        this.track.scrollTo({left:slide.offsetLeft-this.slides[0].offsetLeft,behavior:this.reduced.matches?'instant':'smooth'});
      }
      syncGallery() {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index === this.index) return;
        this.slides[this.index]?.querySelectorAll('video').forEach(video => video.pause());
        this.index = index;
        const isVideo = Boolean(this.slides[index]?.querySelector('video, iframe'));
        this.querySelector('.gtp-top__gallery-bottom').hidden = isVideo;
        this.querySelector('.gtp-top__gallery-label').hidden = isVideo;
        this.querySelector('[data-top-counter]').textContent = `${index+1} / ${this.slides.length}`;
        this.thumbs.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.topGo)===index)));
        const thumb = this.thumbs.querySelector(`[data-top-go="${index}"]`);
        if (thumb) this.thumbs.scrollTo({left:thumb.offsetLeft-this.thumbs.offsetLeft-this.thumbs.clientWidth/2+thumb.clientWidth/2,behavior:this.reduced.matches?'instant':'smooth'});
      }
      syncTier() {
        const tier = this.querySelector('[data-top-tier]:checked');
        if (!tier) return;
        this.querySelector('[data-top-price]').textContent = tier.dataset.price;
        this.querySelector('[data-top-sticky-price]').textContent = `${tier.dataset.name} · ${tier.dataset.price}`;
        const compare = this.querySelector('[data-top-compare]');
        const save = this.querySelector('[data-top-save]');
        compare.textContent = tier.dataset.compare;
        save.textContent = tier.dataset.save;
        compare.hidden = save.hidden = tier.dataset.hasSaving !== 'true';
        this.atc.disabled = tier.dataset.available !== 'true';
        this.querySelector('[data-top-atc-label]').textContent = this.atc.disabled ? this.atc.dataset.soldOut : this.atc.dataset.label;
      }
      async addToCart(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || this.atc.disabled) return;
        this.busy = true;
        this.atc.disabled = true;
        this.querySelectorAll('[data-top-tier]').forEach(tier => { tier.disabled = true; });
        const label = this.querySelector('[data-top-atc-label]');
        const error = this.querySelector('[data-top-error]');
        label.textContent = this.dataset.adding;
        error.hidden = true;
        this.form.setAttribute('aria-busy','true');
        try {
          const tier = this.querySelector('[data-top-tier]:checked');
          const response = await fetch(this.dataset.addUrl, {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(tier.value),quantity:1}]})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
          this.busy = false;
          this.querySelectorAll('[data-top-tier]').forEach(tier => { tier.disabled = false; });
          this.form.removeAttribute('aria-busy');
          this.syncTier();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtp-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setup(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const viewport = root.querySelector('.gtp-ugc__window');
      const track = root.querySelector('.gtp-ugc__track');
      const originals = [...track.children];
      if (!originals.length) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, warm = false, stopped = false, offset = 0, last = 0, frame = 0, step = 0;
      const near = new Set();
      const playing = new Set();
      const canMove = () => visible && !document.hidden && !reduced.matches && !stopped;
      const sync = video => {
        const nearby = warm && near.has(video);
        if (nearby && video.dataset.poster && !video.getAttribute('poster')) {
          video.poster = video.dataset.poster;
        }
        // A poster is sufficient off screen or when the visitor requests less data/motion.
        const loadClip = nearby && !reduced.matches && !navigator.connection?.saveData;
        if (loadClip && !video.getAttribute('src')) {
          video.preload = 'metadata';
          video.src = video.dataset.src;
        } else if (!nearby && video.getAttribute('src')) {
          video.pause();
          video.removeAttribute('src');
          video.preload = 'none';
          video.load();
        }
        video.muted = true;
        if (loadClip && playing.has(video) && canMove()) {
          if (video.paused) video.play().catch(() => {});
        } else if (!video.paused) video.pause();
      };
      const loadObserver = new IntersectionObserver(entries => {
        entries.forEach(({target, isIntersecting}) => {
          if (isIntersecting) near.add(target); else near.delete(target);
          sync(target);
        });
      }, { root: viewport, rootMargin: '0px 120px', threshold: 0 });
      const playObserver = new IntersectionObserver(entries => {
        entries.forEach(({target, isIntersecting}) => {
          if (isIntersecting) playing.add(target); else playing.delete(target);
          sync(target);
        });
      }, { root: viewport, threshold: .05 });
      const observe = card => {
        const video = card.querySelector('video');
        video.muted = true;
        video.addEventListener('loadeddata', () => { if (reduced.matches && video.currentTime === 0) video.currentTime = .1; });
        loadObserver.observe(video);
        playObserver.observe(video);
      };
      originals.forEach(observe);
      const resize = new ResizeObserver(() => {
        step = originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        while (track.children.length * step < viewport.clientWidth + step * 2) {
          const copy = originals[track.children.length % originals.length].cloneNode(true);
          copy.removeAttribute('data-shopify-editor-block');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelector('video').removeAttribute('src');
          track.append(copy);
          observe(copy);
        }
      });
      resize.observe(viewport);
      const tick = time => {
        frame = 0;
        if (!root.isConnected || !canMove()) { last = 0; return; }
        if (last) offset += Math.min(time - last, 50) * .022;
        last = time;
        const first = track.firstElementChild;
        if (step && offset >= step) { offset -= step; track.append(first); }
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        frame = requestAnimationFrame(tick);
      };
      const refresh = () => {
        track.querySelectorAll('video').forEach(sync);
        if (canMove() && !frame) frame = requestAnimationFrame(tick);
        if (!canMove()) { cancelAnimationFrame(frame); frame = 0; last = 0; }
        if (reduced.matches) { offset = 0; track.style.transform = ''; }
      };
      const sectionObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        refresh();
      });
      sectionObserver.observe(root);
      // Fetch nearby clips before vertical scrolling reaches the strip. Posters
      // remain visible while buffering or when mobile Safari blocks autoplay.
      const warmObserver = new IntersectionObserver(entries => {
        warm = entries[0].isIntersecting;
        refresh();
      }, { rootMargin: '350px 0px' });
      warmObserver.observe(root);
      viewport.addEventListener('click', () => { stopped = !stopped; refresh(); });
      viewport.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); stopped = !stopped; refresh(); } });
      document.addEventListener('visibilitychange', refresh);
      reduced.addEventListener('change', refresh);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        cancelAnimationFrame(frame); loadObserver.disconnect(); playObserver.disconnect(); sectionObserver.disconnect(); warmObserver.disconnect(); resize.disconnect();
        document.removeEventListener('visibilitychange', refresh); reduced.removeEventListener('change', refresh);
      });
    }
    document.querySelectorAll('[data-gtp-ugc]').forEach(setup);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gtp-ugc]').forEach(setup));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField) {
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const summaryElm = event.target;
      const menuItem = summaryElm.closest('.list-menu__item-list');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rayofi-catalogue"]) return;
  try {
    
  function enhanceRayofiCatalogue(root) {
    root.querySelectorAll('.rc-sort:not([data-enhanced])').forEach(form => {
      form.dataset.enhanced = 'true';
      form.querySelector('select').addEventListener('change', () => form.requestSubmit());
    });
  }
  enhanceRayofiCatalogue(document);
  document.addEventListener('shopify:section:load', event => enhanceRayofiCatalogue(event.target));

  } catch(e) { console.error(e); }
})();
})();
